import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const New = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g stroke={color} clipPath="url(#a)">
        <path
          fill="#fff"
          strokeLinejoin="round"
          d="M1.562 12.281c1.563-1.219 1.925-5.398 0-7C3.906 5.906 7.282 5 8 2.031c.719 2.969 3.969 4 6.344 3.25-1.375 2-1.281 5.281.156 7-2.094-.813-5.937.719-6.5 3.313C7.344 13 3.24 11.265 1.562 12.28Z"
        ></path>
        <path strokeLinecap="round" d="M7.974 6.724v4.553M5.724 9h4.553"></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .745h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

export default New
